import { Card, Row, Col, Statistic } from "antd";
import { LineChartOutlined } from "@ant-design/icons";
import { IntelligenceDto } from "dtos/application.dto";
import { formatMoney } from "utils/functions";
import { twColors } from "utils/constants";

type OverViewProps = {
  data: IntelligenceDto;
};

const DailyAnalytics = ({ data }: OverViewProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {/* Summary Metrics */}
      <Row gutter={16}>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Daily True Profit"
              value={data.daily_true_profit}
              valueStyle={{
                color: Number(data?.daily_true_profit ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Profit Std Dev"
              value={data.daily_profit_std ?? 0}
              valueStyle={{
                color: Number(data?.daily_profit_std ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false, false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Profit Variance"
              value={data.daily_profit_variance ?? 0}
              valueStyle={{
                color: Number(data?.daily_profit_variance ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false, false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Revenue Std Dev"
              value={data.daily_revenue_std ?? 0}
              valueStyle={{
                color: Number(data?.daily_revenue_std ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false, false)}`}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Revenue Variance"
              value={data.daily_revenue_variance ?? 0}
              valueStyle={{
                color: Number(data?.daily_revenue_variance ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false, false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Avg Ending Balance"
              value={data?.daily_ending_balances?.avg_ending_balance}
              valueStyle={{
                color:
                  Number(data?.daily_ending_balances?.avg_ending_balance ?? 0) > 0
                    ? twColors.green600
                    : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Ending Balance Std Dev"
              value={data?.daily_ending_balances?.std_dev}
              valueStyle={{
                color: Number(data?.daily_ending_balances?.std_dev ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false, false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Ending Balance Range"
              value={`${data?.daily_ending_balances?.min ?? "-"} - ${data?.daily_ending_balances?.max ?? "-"}`}
              valueRender={() => (
                <span>
                  <span
                    style={{
                      color: Number(data?.daily_ending_balances?.min ?? 0) >= 0 ? twColors.green600 : twColors.red600,
                    }}
                    className="text-"
                  >
                    {formatMoney(data?.daily_ending_balances?.min, false) ?? "-"}
                  </span>

                  <span style={{ margin: "0 8px", color: "#999" }}>–</span>

                  <span
                    style={{
                      color: Number(data?.daily_ending_balances?.max ?? 0) >= 0 ? twColors.green600 : twColors.red600,
                    }}
                    className="text-"
                  >
                    {formatMoney(data?.daily_ending_balances?.max, false) ?? "-"}
                  </span>
                </span>
              )}
            />
          </Card>
        </Col>
      </Row>

      {/* Cash Flow Distribution */}
    </div>
  );
};

export default DailyAnalytics;
